/**
 * Central route table. Every page path is declared here once so links, the
 * router, and navigation items all reference the same source of truth.
 */
export const ROUTES = {
  login: "/login",
  overview: "/",
  tools: "/tools",
  prospectLetter: "/tools/prospect-letter",
  netsuiteContacts: "/tools/netsuite-contacts",
  timesheet: "/timesheet",
  aiAssessment: "/ai-assessment",
  aiAssessmentTake: "/ai-assessment/take",
  aiAssessmentResults: "/ai-assessment/results/:id",
  aiAssessmentAdmin: "/ai-assessment/admin",
  aiAssessmentAdminUser: "/ai-assessment/admin/users/:userId",
  email: "/email",
  emailMessage: "/email/:messageId",
  asanaTasks: "/asana-tasks",
  clientMomentum: "/momentum",
  clientMomentumClient: "/momentum/:clientKey",
  websites: "/websites",
  settingsAccess: "/settings/access",
} as const;

export type RouteKey = keyof typeof ROUTES;

/** Build a concrete path for the assessment results route. */
export function assessmentResultsPath(id: string): string {
  return ROUTES.aiAssessmentResults.replace(":id", id);
}

/** Build a concrete path for an individual user's assessment history (admin). */
export function assessmentAdminUserPath(userId: string): string {
  return ROUTES.aiAssessmentAdminUser.replace(":userId", userId);
}

/** Build a concrete path for a single email message. */
export function emailMessagePath(messageId: string): string {
  return ROUTES.emailMessage.replace(":messageId", messageId);
}

/** Build a concrete path for one client's Client Momentum detail page. */
export function clientMomentumClientPath(clientKey: string): string {
  return ROUTES.clientMomentumClient.replace(":clientKey", clientKey);
}
